@if (form) {
	<div
		class="quantity-selector"
		[formGroup]="form"
	>
		<ngx-slider
			formControlName="percent"
			[options]="sliderOptions()"
			[manualRefresh]="manualRefreshSlider"
			[tuiSkeleton]="isLoadingOrders()"
		/>

		<div>
			<div class="quantity-inputs">
				<tui-textfield
					iconStart="@tui.percent"
					[tuiTextfieldCleaner]="false"
					tuiTextfieldSize="s"
					[tuiSkeleton]="isLoadingOrders()"
				>
					<input
						[min]="minPercent"
						[step]="0.5"
						tuiInputNumber
						[tuiNumberFormat]="{
							decimalMode: 'not-zero',
							rounding: 'truncate',
							decimalSeparator: ',',
						}"
						inputNumberSigns
						placeholder="0"
						formControlName="percent"
						(input)="putCursorEnd($event.target)"
					/>
				</tui-textfield>

				<div class="percent-input">
					<tui-textfield
						class="field"
						[iconStart]="'@font.' + ('quantitySelector.pcs' | translate)"
						[tuiTextfieldCleaner]="false"
						tuiTextfieldSize="s"
						[tuiSkeleton]="isLoadingOrders()"
					>
						<input
							[min]="0"
							[step]="1"
							tuiInputNumber
							formControlName="qty"
							placeholder="0"
							[tuiNumberFormat]="{
								precision: maxDecimalCount,
								decimalMode: 'not-zero',
								rounding: 'truncate',
								decimalSeparator: ',',
							}"
							inputNumberSigns
							(input)="putCursorEnd($event.target)"
						/>
					</tui-textfield>
				</div>
			</div>
			<tui-error
				class="error"
				[error]="getFieldError('qty')"
			/>
		</div>
	</div>
}
